"use client";

import React, { useEffect, useRef } from "react";
import Image from "next/image";
import TextCarousel from "../ui/textCarousel";
import ReelsSlider from "../slider/reelsSlider";
import RevealElement from "../revealElement";
import BottomCurves from "../curves/bottomCurves";
import Layer1 from "../../../public/emoji-layer-1.png";
import Layer2 from "../../../public/emoji-layer-2.png";
import Layer3 from "../../../public/emoji-layer-3.png";

import gsap from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function VideoTestimonial({ data }: any) {
    const emojiOne = useRef<HTMLImageElement>(null);
    const emojiTwo = useRef<HTMLImageElement>(null);
    const emojiThree = useRef<HTMLImageElement>(null);
    const reelContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const emojiTL = gsap.timeline({
            scrollTrigger: {
                trigger: reelContainerRef.current,
                start: "bottom bottom",
                end: "bottom top",
                scrub: 1.3,
                markers: false,
            },
        });

        emojiTL.to(emojiOne.current, { yPercent: -10 }).to(emojiTwo.current, { yPercent: -20 }, "<").to(emojiThree.current, { yPercent: -5 }, "<");

        setTimeout(() => {
            ScrollTrigger.refresh();
        }, 1500)
    }, []);

    return (
        <section className="pt-20 pb-32 px-0 bg-purpleTurquoise">
            <RevealElement>
                <TextCarousel text={data.heading} color={""} colouredPosition={0} />
            </RevealElement>

            <div className=" mt-32 pb-[12.5vw]">
                <ReelsSlider slides={data.videos} />
            </div>
            <div ref={reelContainerRef}>
                <Image
                    src={Layer1}
                    alt={""}
                    width={1920}
                    height={1080}
                    className={`absolute bottom-0 left-0 right-0 object-contain translate-y-[0%] scale-[2] sm:scale-[1] origin-bottom`}
                    ref={emojiOne}
                />
                <Image
                    src={Layer2}
                    alt={""}
                    width={1920}
                    height={1080}
                    className={`absolute bottom-0 left-0 right-0 object-contain translate-y-[0%] scale-[2] sm:scale-[1] origin-bottom`}
                    ref={emojiTwo}
                />
                <Image
                    src={Layer3}
                    alt={""}
                    width={1920}
                    height={1080}
                    className={`absolute bottom-0 left-0 right-0 object-contain translate-y-[0%] z-10 scale-[2] sm:scale-[1] origin-bottom`}
                    ref={emojiThree}
                />
            </div>
            <BottomCurves direction="right" color={data.waveBgColor.waveBgColor} />
        </section>
    );
}
